import { http } from '@/api/http';

export default  {
    /**
     * 理论练习
     */
    // 理论练习题库存（返回数量）
    // 2020/4/3 Xia 为了兼容旧版移动端配对题使用v2接口
    getTheoryStudyStock(data) {
        return http.get('/api/TheoryIStudy/TopicStockV2', data);
    },
    startTheoryPractice(data) {
        return http.get('/api/TheoryIStudy/PractiseV2', data);
    },
    theoryStudyDetail(id) {
        return http.get(`/api/TheoryIStudy/Practise/${id}`);
    },
    queryTheoryStudy(data) {
        return http.get('/api/TheoryIStudy/Query', data);
    },
    submitTheoryStudy(guid, data) {
        return http.post(`/api/TheoryIStudy/Submit/${guid}`, data);
    },
    // 提交练习后调用，获得本次练习的作答概况
    theoryStudyAchievement(id) {
        return http.get(`/api/TheoryIStudy/Achievement/${id}`);
    },

    /**
     * 图像练习/学习
     */
    getImgStudyStock(data) {
        return http.get('/api/ImageIStudy/quantity', data);
    },
    getImgPracticeStock(data) {
        return http.get('/api/ImageIStudy/PractiseStock', data);
    },
    queryImageStudy(data) {
        return http.get('/api/ImageIStudy/Query', data);
    },

    /**
     * 理论考试
     */
    // 考试记录
    queryExams(data) {
        return http.get('/api/Exam/Achievements', data);
    },
    // 正常考试的接口
    examDetail(id) {
        return http.get(`/api/Exam/${id}`);
    },
    // 开始补考的接口
    resitExamDetail(id) {
        return http.get(`/api/Exam/Resit/${id}`);
    },
    saveTheoryExam(id, data) {
        return http.post(`/api/Exam/Save/Theory/${id}`, data, { noShowError: true });
    },
    submitTheoryExam(id, data) {
        return http.post(`/api/Exam/Submit/Theory/${id}`, data);
    },
    // 提交考试后调用，获得本次考试的作答概况
    theoryExamAchievement(id) {
        return http.get(`/api/Exam/Achievement/${id}`);
    },
    examLeavetimes(id) {
        return http.post(`/api/Exam/${id}/leave-times`);
    },
    // 试卷基本信息，用于考试须知页
    getExamInstruction(id) {
        return http.get(`/api/Exam/GetInstructions/${id}`);
    },

    /**
     * 模拟练习
     */
    currentMockExam(id) {
        return http.get(`/api/MockExam/Current/${id}`);
    },
    newMockExam(id) {
        return http.get(`/api/MockExam/New/${id}`);
    },
    saveTheoryMockExam(id, guid, data) {
        return http.post(`/api/MockExam/Save/Theory/${id}/${guid}`, data, { noShowError: true });
    },
    submitTheoryMockExam(id, guid, data) {
        return http.post(`/api/MockExam/Submit/Theory/${id}/${guid}`, data);
    },
    theoryMockExamAchievement(id) {
        return http.get(`/api/MockExam/Achievement/${id}`);
    },
    // 考卷详情
    mockExamHistory(id) {
        return http.get(`/api/MockExam/History/${id}`);
    },
    // 模拟考试记录
    queryMockExams(data) {
        return http.get('/api/MockExam/Achievements', data);
    },

    /**
     *  自定义环节（比如问卷）
     */
    // 问卷的查询接口（问卷数据、作答数据）
    getQuestionnaireReply(id) {
        return http.get(`/surveyapi/questionnaire/${id}/reply`);
    },
    // 提交问卷
    postQuestionnaireReply(id, data) {
        return http.post(`/surveyapi/questionnaire/${id}/reply`, data);
    },

    // 开始自定义环节（因为是独立的服务，接口需要记录）
    startCustomProcess(processID) {
        return http.put(`/api/CustomizeProcess/Start/${processID}`);
    },
    // 结束自定义环节
    finishCustomProcess(processID) {
        return http.put(`/api/CustomizeProcess/Finish/${processID}`);
    },

    /**
     * 任务
     */
    //培训任务
    getMyTask(data) {
        return http.get('/api/Training/MyTask', data);
    },
    //培训任务详情
    getTaskDetail(id) {
        return http.get('/api/TrainingOnline/MyTrace/' + id)
    },

    /**
     * 学习
     */
    courseStudy(id) {
        return http.get(`/api/Study/${id}`);
    },
    courseStudyRecord(id, data) {
        return http.put(`/api/Study/Record/${id}`, data, {contentType:'form'});
    },
    courseStudyPlayback(id, data) {
        return http.put(`/api/Study/Playback/${id}`, data, {contentType:'form'});
    },

    /**
    * 个人主页
    */
    //未完成任务
    getUnfinishedTask() {
        return http.get(`/api/Dashboard/Student/TrainList`);
    },
    //个人情况统计
    getMyStatistic() {
        return http.get(`/api/Dashboard/Student/MyStatics`);
    },
    //考试通过状态
    getExamStatistics() {
        return http.get(`/api/Dashboard/Student/ExamStatusStatics`);
    },
    //课程学习状态
    getCourseStatistics() {
        return http.get(`/api/Dashboard/Student/CourseStatusStartics`);
    },
    //理论错题统计
    getTheoryWrong() {
        return http.get(`/api/Dashboard/Student/TheoryWrongStatics`);
    },
    //图像错题统计
    getImageWrong() {
        return http.get(`/api/Dashboard/Student/ImageWrongStatics`);
    },

    /**
     * 岗前测评
     */
    getPrejobType() {
        return http.get(`${this.mobileStudyUrl}/api/Examine/GetCategory`);
    },
    startPrejobExam(id) {
        return http.get(`${this.mobileStudyUrl}/api/Examine/StartExamine/${id}`);
    },
    submitPrejobTheory(id, data) {
        return http.post(`${this.mobileStudyUrl}/api/Examine/TheorySubmit/${id}`, data);
    },
    submitSensitive(id, data) {
        return http.post(`${this.mobileStudyUrl}/api/Examine/SensitivitySubmit/${id}`, data, {contentType:'form'});
    },
    GetEvaluationByStudent() {
        return http.get(`${this.mobileStudyUrl}/api/Examine/GetEvaluationByStudent`);
    },
    GetEvaluationByTrainer(id) {
        return http.get(`${this.mobileStudyUrl}/api/Examine/EvaluationByTrainer/${id}`);
    },

    /**
     *  直播
     */
    getLiveRooms(data) {
        return http.get(`/api/live/room`, data);
    },
    getLiveRoomDetail(id, data) {
        return http.get(`/api/live/room/${id}`, data);
    },
    getLiveComment(id, data) {
        return http.get(`/api/live/room/${id}/comments`, data);
    },
    postLiveComment(id, comment) {
        return http.post(`/api/live/room/${id}/comments`, {comment}, {contentType:'form'});
    },
    getOnlineNum(id) {
        return http.get(`/api/live/room/${id}/pc/online-number`, {}, {noShowError: true});
    },
    gradeLive(id, score) {
        return http.put(`/api/live/room/${id}/grading`, {score}, {contentType:'form'});
    },

    /**
     *  学分
     */
    getMyCredit(){
        return http.get(`/api/UserCredit/Mine`);
    },
    //我的学分明细
    getCreditRecords(data) {
        return http.get(`/api/UserCredit/Histroy`,data);
    },
    //我的学分明细
    getMyRankRecords(data) {
        return http.get(`/api/UserCredit/MyHistroy`,data);
    },
    //排行榜
    getCreditRank(type){
        return http.get(`/api/UserCredit/Rank?type=${type}`);
    },
    //排行榜
    getOrgCreditRank(type){
        return http.get(`/api/UserCredit/OrgRank?type=${type}`);
    },
    //获取我的 按类型学分
    getMyCreditType(date){
        return http.get(`/api/UserCredit/MyCreditByType?date=${date}`);
    },
    //获取我的 按月份学分
    getMyCreditMonth(date){
        return http.get(`/api/UserCredit/MyCreditByMonth?date=${date}`);
    },
     // 培训计划属性详情
     getTrainingStatus(id) {
        return http.get(`/api/TrainingOnline/GetTrainingStatus/${id}`);
    },
     /**
     *  电子签名
     */
    postTrainingOnlineSignature(id,data) {
        return http.post(`/api/TrainingOnline/Signature/${id}`,data, { contentType: 'file' });
    },
    getTrainingResult(id) {
        return http.get(`/api/TrainingOnline/GetTrainingResult/${id}`);
    },
};
